import theme from '@styles/theme';
export default {
  newLabel: {
    display: 'block',
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: 500,
    fontSize: theme.fontSizes.omnibus,
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    color: theme.rawColors.neutralBlack,
    marginBottom: '4px'
  },
  descriptionArea: (isSmall = false, isSlider = false) => ({
    position: 'relative',
    p: isSmall ? '8px 16px 24px' : ['8px 16px 24px', '8px 16px 24px', '8px 16px 24px', '16px 16px 40px'],
    ...(isSlider ? {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    } : {})
  }),
  descriptionSkeletonContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: theme.zIndex.documentHigh,
    bg: theme.rawColors.neutralWhite,
    p: '8px 16px 24px'
  },
  infoNameSkeleton: {
    mb: '4px'
  },
  infoPriceSkeleton: {
    mb: '4px'
  },
  infoColorSkeleton: {
    mr: 'calc(1rem / 4)'
  },
  nameLink: {
    display: 'block',
    textDecoration: 'none',
    color: 'inherit',
    outline: 'none',
    '&:hover': {
      textDecoration: 'underline'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.blue500}`,
      outlineOffset: '2px'
    }
  }
};